export const CUSTOM_SEGMENT_KEY_PREFIX = "contanuity"
export const SUBMODULES = {
  APP_SITE: "APP_SITE",
  CTV_CHANNEL: "CTV_CHANNEL",
  // CONTENT: "CONTENT",
  EXCHANGE: "EXCHANGE",
  GEO: "GEO",
  ENVIRONMENT: "ENVIRONMENT",
  PLATFORM: "PLATFORM",
  TIME: "TIME",
  SEGMENT: "SEGMENT",
  CUSTOM_SEGMENT: "CUSTOM_SEGMENT"
} as const;

export const VERB_USAGE = {
  INCLUDE: "INCLUDE",
  EXCLUDE: "EXCLUDE",
  REQUIRE: "REQUIRE",
  ALL: "ALL",
} as const;

export const STATUS = [
  { label: "Active", value: "active" },
  { label: "Archived", value: "inactive" },
] as const;

export const CTV_CHANNELS_KEY = {
  default: () => ["channels"] as const,
  all: (
    search?: string,
    lineItemId?: number,
    sortBy?: string,
    savedOnly?: boolean,
    page?: number,
    size?: number
  ) =>
    [
      ...CTV_CHANNELS_KEY.default(),
      search,
      lineItemId,
      sortBy,
      savedOnly,
      page,
      size,
    ] as const,
} as const;


export const TARGETING_EXPRESSION_MODULES_DEFAULT_VALUES = {
  app_site: {
    deal_id_list: {
      value: {
        included: [],
        excluded: [],
      },
    },
    domain_list: {
      value: { included: [], excluded: [] },
    },
    deal_id: {
      value: {
        included: [],
        excluded: [],
      },
    },
    app_name: {
      value: {
        included: [],
        excluded: [],
      },
    },
  },
  environment: {
    ad_position: {
      value: [],
      type: null,
    },
    environment_type: {
      value: [],
      type: null,
    },
  },
  exchange: {
    inventory_source: {
      value: [],
      type: null,
    },
  },
  geo: {
    country: {
      value: [],
      type: null,
    },
    region: {
      value: [],
      type: null,
    },
    city: {
      value: [],
      type: null,
    },
    zip_code_list: {
      value: { included: [], excluded: [] },
    },
  },
  platform: {
    device_type: {
      value: [],
      type: null,
    },
  },
  time: {
    timeOfWeek: {
      key: "user_time_of_week",
      value: [
        {
          startDay: null,
          endDay: null,
          startTime: null,
          endTime: null,
        },
      ],
      type: "include",
    },
  },
  user: {
    segment: {
      value: {
        included: new Map(),
        excluded: new Map(),
        required: new Map(),
      },
    },
    custom_segment: {
      value: {
        segmentIds: []
      }
    }
  },

} as const; 
